<!-- 变种属性映射 -->
<template>
  <div id="variantAttributes">
    <Breadcrumb></Breadcrumb>

    <!--<div class="form-body">-->
    <div class="amazon_coll_tab">
      <div class="form-body">
        <el-button @click="noteDialogVisible = true" type="warning" size="small">新增</el-button>
        <el-button @click="noteDialogVisible = true" type="warning" size="small">修改</el-button>
      </div>
        <!-- <div style="float: right">
                    <el-button size="small" type="primary">采集数据</el-button>
                    <el-button size="small" type="primary"><router-link target="_blank" class="r_link" to="/createProduct">创建产品</router-link></el-button>
                    <el-button size="small" type="primary">同步产品</el-button>
                    <el-button type="primary" size="small" @click="getAmazonTemplate">导出excel模版</el-button>
                </div> -->
      <!-- <div>
        <div class="leftarea"></div>
        <div class="rightarea">
        </div>
      </div> -->
      <div class="form-body">
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="form.pageNum"
          :page-size="form.pageSize"
          :page-sizes="[100, 200, 300, 400]"
          @pagination="getListZz"
        />
        <el-table
          v-loading="loading"
          id="outTable"
          border
          :data="tableData"
          style="width: 100%"
          lazy
          :load="loadSku"
        >
          <el-table-column type="selection" width="40" align="center"></el-table-column>
          <el-table-column label="平台属性" prop="price" align="center">
            <template slot-scope="scope">
              <span>平台属性</span>
            </template>
          </el-table-column>
          <el-table-column label="亚马逊属性" prop="price" align="center">
            <template slot-scope="scope">
              <span>亚马逊属性</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false"   title="新增" width="50%" :visible.sync="noteDialogVisible" class="note-dialog">
      <el-row>
        <el-col>
          <el-form ref="queryForm" label-position="left" label-width="120px">
            <el-form-item label="平台属性" prop="menuName" required>
              <el-input placeholder="请输入平台属性" clearable size="small" />
            </el-form-item>
            <el-form-item label="亚马逊属性" prop="status" required>
              <el-input placeholder="请输入亚马逊属性" clearable size="small" />
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="noteDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="closeDialogVisible" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/Breadcrumb';
import { loadTableData } from '@/api/product/amazon';
import { getTree } from '@/api/tree/tree';

export default {
  name: 'CollectionBox',
  components: {
    Breadcrumb,
  },
  data() {
    return {
      excelDialogVisible: false,
      progress: {
        value: 0, //进度条的值
        status: 'success', //进度条的颜色显示
        rows: 0, //成功条数
        msg: [], //错误的信息
        fileSrc: null, //下载的路径
      },
      loading: false,
      total: 0,
      currentPage: 1,
      form: {
        pageNum: 1,
        pageSize: 100,
        account: '',
        searchStr: null,
        // dataSource: '',//数据来源
        searchType: 1,
        site: '', //站点选择
        sell: '', //售卖形式
        sortField: 'UPDATE_TIME', //排序方式
        byAsc: 'desc', //升序或者降序
      },
      remark: undefined, //备注

      props: {
        id: 'id',
        children: 'children',
        label: 'typeNme',
      },
      dpxs: true,
      bzxs: true,
      cz: true,
      zcd: false,
      fcd: true,
      dataSource: 'all',
      dpzdxzList: [],
      tableData: [],
      dpsmxsList: [],
      ids: [], //选中的ID
      noteDialogVisible: false, //备注弹框
      shopeeList: [], //批量对象
    };
  },
  computed: {
    dpList() {
      return this.$store.state.product.amazon.shopList;
    },
  },
  created() {
    this.getListZz(); //获取表格数据
  },

  methods: {
    //获取第一节点
    getListZz: function() {
      this.loading = true;
      this.form['pubStatus'] = '01'; //发布状态pubStatus，01采集箱，02待发布，03发布中，04发布失败，05在线产品
      loadTableData(this.form)
        .then((res) => {
          if (res.code == 200) {
            //对数据进行处理
            this.preHandleData(res.rows);
            this.total = res.total;
            this.$store.dispatch('setIfReload', true);
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    preHandleData(data) {
      let finalData = [];
      let temp = [];
      data.forEach((row) => {
        let map = {
          collId: row.collId,
          createTime: row.createTime,
          updateTime: row.updateTime,
          pId: row.pId,
          proTitle: row.proTitle,
          remark: row.remark,
          dataSource: row.dataSource,
          dataUrl: row.dataUrl,
          children: [],
        };

        if (temp.indexOf(JSON.stringify(map)) == -1) {
          temp.push(JSON.stringify(map));
        }
      });
      temp.forEach((str) => {
        finalData.push(JSON.parse(str));
      });
      finalData.forEach((head) => {
        data.forEach((row, index) => {
          if (head.pId == row.pId) {
            row.pId += '_' + row.skuId;
            head.children.push(row);
          }
        });
      });
      this.tableData = finalData;

      let tableData = this.tableData;
    },
    loadSku(tree, treeNode, resolve) {
      let xalist = [];
      for (let i = 0; i < tree.sAmazonSku.length; i++) {
        var aa = {
          bzxs: false,
          dpxs: false,
          cz: false,
          zcd: true,
          fcd: false,
          pId: tree.sAmazonSku[i].skuid,
          mainPic: tree.mainPic,
          proTitle: tree.proTitle,
          skuno: tree.sAmazonSku[i].skuno,
          aSite: tree.aSite,
          price: tree.sAmazonSku[i].price,
          invent: tree.sAmazonSku[i].invent,
          createTime: tree.createTime,
          updateTime: tree.updateTime,
          dataSource: tree.dataSource,
          dataUrl: tree.dataUrl,
        };
        xalist.push(aa);
      }
      resolve(xalist);
    },
    closeDialogVisible() {
      this.noteDialogVisible = false;
    },
  },
  mounted() {},
};
</script>

<style scoped>
.left-12 {
  font-size: 12px;
  text-align: left;
}

.color-999 {
  color: #999;
}

.scro >>> .el-scrollbar__wrap {
  overflow-x: hidden;
}

.rightarea {
  float: right;
}

.font1 {
  font-size: 14px;
}
</style>
